import { render, staticRenderFns } from "./ExtratoClienteTableMixComercializado.vue?vue&type=template&id=19f9b13d&scoped=true&"
import script from "./ExtratoClienteTableMixComercializado.vue?vue&type=script&lang=js&"
export * from "./ExtratoClienteTableMixComercializado.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoClienteTableMixComercializado.vue?vue&type=style&index=0&id=19f9b13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9b13d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
